import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'reactstrap';
import { useIntl } from 'react-intl';

const FiltersResetButton = ({ handleReset }) => {
  const intl = useIntl();

  return (
    <div className="btns-group">
      <Button
        color="link"
        className="action-clear action-clear-all"
        onClick={handleReset}
      >
        {intl.formatMessage({ defaultMessage: 'Clear' })}
      </Button>
    </div>
  );
};

FiltersResetButton.propTypes = {
  handleReset: PropTypes.func.isRequired,
};

export default FiltersResetButton;
